import React from "react";
import {Link} from "react-router-dom";
import {Menu} from "semantic-ui-react";
import MadkomLogo from "./../madkom-logo";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer>
      <Menu widths={"1"}>
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.5rem'}}>
          <Link to="/">
            <MadkomLogo/>
          </Link>
          <span style={{marginTop: '0.25rem'}}>Copyright &copy; {currentYear} Madkom SA. Wszystkie prawa zastrzeżone.</span>
        </div>
      </Menu>
    </footer>
  )
};

export {Footer};
export default Footer;


// WEBPACK FOOTER //
// ./src/components/footer/Footer.js